export const tokens = {
  layout: {
    shell: 'max-w-[1600px]',
  },
  background: {
    app: 'bg-[radial-gradient(circle_at_top_left,rgba(16,185,129,0.16),transparent_28%),radial-gradient(circle_at_85%_15%,rgba(20,184,166,0.13),transparent_26%),radial-gradient(circle_at_50%_62%,rgba(132,204,22,0.09),transparent_30%),linear-gradient(180deg,#f3fbf7_0%,#eef8f4_48%,#f8fcfa_100%)] dark:bg-[radial-gradient(circle_at_top_left,rgba(16,185,129,0.18),transparent_24%),radial-gradient(circle_at_85%_15%,rgba(20,184,166,0.14),transparent_24%),radial-gradient(circle_at_50%_62%,rgba(132,204,22,0.08),transparent_28%),linear-gradient(180deg,#051311_0%,#081b18_58%,#09141c_100%)]',
  },
  surface: {
    card:     'bg-white dark:bg-zinc-900 shadow-[0_1px_3px_rgba(0,0,0,0.05),0_1px_2px_rgba(0,0,0,0.03)] dark:border dark:border-white/8',
    elevated: 'bg-white dark:bg-zinc-800 shadow-[0_4px_12px_rgba(0,0,0,0.08)] dark:shadow-[0_4px_12px_rgba(0,0,0,0.24)]',
    subtle:   'bg-gray-50/80 dark:bg-zinc-900/60',
    shell: 'bg-white/78 dark:bg-zinc-950/72 backdrop-blur-xl border border-emerald-100/70 dark:border-white/10 shadow-[0_18px_60px_rgba(15,23,42,0.08)] dark:shadow-[0_18px_60px_rgba(0,0,0,0.28)]',
    shellMuted: 'bg-white/68 dark:bg-zinc-950/58 backdrop-blur-xl border border-white/70 dark:border-white/8 shadow-[0_14px_40px_rgba(15,23,42,0.06)] dark:shadow-[0_14px_40px_rgba(0,0,0,0.24)]',
    hero: 'bg-[linear-gradient(135deg,rgba(255,255,255,0.94)_0%,rgba(255,255,255,0.84)_48%,rgba(236,253,245,0.72)_100%)] dark:bg-[linear-gradient(135deg,rgba(2,44,34,0.94)_0%,rgba(12,74,64,0.9)_52%,rgba(8,47,73,0.86)_100%)] border border-white/75 dark:border-white/10 backdrop-blur-xl shadow-[0_22px_70px_rgba(15,23,42,0.1)] dark:shadow-[0_22px_70px_rgba(0,0,0,0.32)]',
    cardGlass: 'bg-gradient-to-br from-white/86 via-white/62 to-emerald-50/38 border border-white/70 border-t-white/85 border-l-white/80 shadow-[0_12px_42px_rgba(15,23,42,0.07)] dark:bg-[linear-gradient(135deg,rgba(3,27,23,0.9)_0%,rgba(5,41,35,0.8)_48%,rgba(7,49,58,0.76)_100%)] dark:border-white/10 dark:border-t-white/18 dark:border-l-white/14 dark:shadow-[0_12px_42px_rgba(0,0,0,0.3)]',
    sidebarShowcase: 'bg-[linear-gradient(180deg,rgba(2,44,34,0.98)_0%,rgba(12,74,64,0.95)_46%,rgba(8,47,73,0.94)_100%)] border border-white/8 shadow-[0_26px_80px_rgba(6,78,59,0.22)]',
  },
  radius: {
    sm:   'rounded-md',       // 6px  — tagy, input chips
    md:   'rounded-lg',       // 8px  — small buttons, kompaktní ovládání
    lg:   'rounded-[10px]',   // 10px — primary buttons
    xl:   'rounded-xl',       // 12px — cards, modal sections
    card: 'rounded-[14px]',   // 14px — primary cards, drawers
    pill: 'rounded-full',     // 999px — badges, toggle pills
  },
  shadow: {
    sm: 'shadow-sm',
    md: 'shadow-md',
    lg: 'shadow-lg shadow-black/5 dark:shadow-black/20',
    xl: 'shadow-xl shadow-black/10 dark:shadow-black/30',
    /**
     * Glow effect — returns a style object, not a class string.
     * Usage: style={tokens.shadow.glowStyle('#22c55e')}
     * For class-only usage, combine with `shadow-lg` and set color via CSS var.
     */
    glow: 'shadow-lg',
    glowStyle: (color: string) => ({
      boxShadow: `0 10px 15px -3px ${color}33, 0 4px 6px -4px ${color}33`,
    }),
  },
  z: {
    base: 'z-0',
    dropdown: 'z-10',
    sticky: 'z-20',
    overlay: 'z-40',
    modal: 'z-50',
    tooltip: 'z-[60]',
    toast: 'z-[70]',
  },
  transition: {
    fast: 'transition-all duration-150',
    normal: 'transition-all duration-300',
    slow: 'transition-all duration-500',
  },
  density: {
    compact: '1',
    comfy:   '1.15',
  },
  safety: {
    danger: '#ef4444',
    warn:   '#f59e0b',
    safe:   '#10b981',
    dangerBg: 'bg-red-500/10 text-red-600 dark:text-red-400',
    warnBg:   'bg-amber-500/10 text-amber-600 dark:text-amber-400',
    safeBg:   'bg-emerald-500/10 text-emerald-600 dark:text-emerald-400',
  },
} as const;
